import React from 'react'

function Card(props) {
    return (
        <>
            <div className="container" onClick={(e) => { props.setDisplay('Branch')}}>
                <div className="cus-card-body">
                    <div className="cus-card-img-box">
                        <img className='cus-card-img' src={props.imgLink} alt="" />
                    </div>
                    <div className="cus-card-text-holder-box">
                        <h6>{props.cardTitle}</h6>
                        <p>{props.cardDesc}</p>
                    </div>
                    {/* <div className="cus-card-button-box">
                        <button type="button" className="cus-card-btn">Primary</button>
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default Card